module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderMobile/DotcomHeaderMobile.module.scss");